import React, { Component, Fragment } from "react";
import moment from "moment";
import { curdActions } from "../../reduxCURD/actions";
import _ from "lodash";
import { ToastService } from "../../utils/toastify";
import ThisTable from "../Common/ThisTable";
import { languageService } from "../../Language/language.service";
import { getAppMockupsTypes } from "../../reduxRelated/actions/diagnosticsActions";
import { CRUDFunction } from "../../reduxCURD/container";
import { materialTypeListSectionSchema } from "./materialTypeSection/materialTypeSectionSchema";
import CustomForm from "../../libraries/form";
import { updateShortSchema } from "../../libraries/form/schemaInterpreter";
import { ButtonActionsTable } from "components/Common/Buttons";
import TooltipContainer from "../../libraries/TooltipContainer";
import { commonSummaryStyle } from "../Common/Summary/styles/CommonSummaryStyle";
import { commonPageStyle } from "../Common/Summary/styles/CommonPageStyle";
import permissionCheck from "../../utils/permissionCheck";
import { ButtonCirclePlus } from "../Common/Buttons";
import ConfirmationDialog, { confirmationDialogWarningMessage } from "../../libraries/ConfirmationDialog";
import Dialog from "../../libraries/Dialog";
import { sectionSchemaGenerator } from "./utils/sectionSchemaGenerator";
import { materialTypeSection } from "./materialTypeSection/materialTypeSections";
import { tableColumnsGenerator } from "./utils/tableColumnsGenerator";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { themeService } from "../../theme/service/activeTheme.service";
import { commonFilterStyles } from "../Common/Filters/styles/CommonFilterStyle";
import { basicColors, retroColors, electricColors } from "../../style/basic/basicColors";
class MaterialTypeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      materialTypesList: [],
      columns: [],
      materialTypeFormSchema: null,
      materialFormState: "create",
      editMode: false,
      openAddEditMaterialForm: false,
      openAddEditMaterialFormData: {},
      confirmationDialog: null,
      selectedMaterial: null,
      dropdownOpen: false,
      page: 0,
      pageSize: 30,
    };

    this.flattenMaterialTypes = this.flattenMaterialTypes.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.handleMaterialActionCallback = this.handleMaterialActionCallback.bind(this);
    this.addMaterialType = this.addMaterialType.bind(this);
    this.updateMaterialType = this.updateMaterialType.bind(this);
    this.deleteMaterialType = this.deleteMaterialType.bind(this);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);

    this.handlePageSave = this.handlePageSave.bind(this);
    this.setSchema = this.setSchema.bind(this);
    this.toggle = this.toggle.bind(this);
    this.pageOptions = [5, 10, 15, 20, 25, 30, 40, 50];
  }

  componentDidMount() {
    this.props.getAppMockupsTypes("materialTypes");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.diagnosticsActionType !== this.props.diagnosticsActionType) {
      if (this.props.diagnosticsActionType === "GET_MATERIALTYPES_SUCCESS") {
        this.props.getAppMockupsTypes("materialTypesSchema");
        this.flattenMaterialTypes(this.props.materialTypes);
      }
    }

    if (prevProps.diagnosticsActionType !== this.props.diagnosticsActionType) {
      if (this.props.diagnosticsActionType === "GET_MATERIALTYPES_SCHEMA_SUCCESS") {
        if (this.props.materialTypesSchema[0] && this.props.materialTypesSchema[0].opt1) {
          this.setSchema(materialTypeSection().opt1.schema);
        } else this.setSchema(this.props.materialTypesSchema[0].opt1.schema);
      }
    }

    if (prevProps.applicationlookupsActionType !== this.props.applicationlookupsActionType) {
      switch (this.props.applicationlookupsActionType) {
        case "APPLICATIONLOOKUPS_CREATE_SUCCESS":
          ToastService.Success(languageService("Material Type added successfully."));
          this.props.getAppMockupsTypes("materialTypes");
          break;

        case "APPLICATIONLOOKUPS_UPDATE_SUCCESS":
          ToastService.Success(languageService("Material Type updated successfully."));
          this.props.getAppMockupsTypes("materialTypes");
          break;

        case "APPLICATIONLOOKUPS_DELETE_SUCCESS":
          ToastService.Success(languageService("Material Type deleted successfully."));
          this.props.getAppMockupsTypes("materialTypes");
          break;

        default:
          break;
      }
    }
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }
  closeDialog() {
    this.setState({ openAddEditMaterialForm: false });
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }
  setSchema(schema) {
    let generatedSchema = sectionSchemaGenerator("Material Type", "materialType", schema);
    let generatedColumns = tableColumnsGenerator(schema);
    let materialTypeFormSchema = updateShortSchema(_.cloneDeep(generatedSchema));

    let columns = [...generatedColumns];

    if (this.props.isIMS) {
      columns.push(
        { Header: languageService("Status"), accessor: "opt1.status" },
        { Header: languageService("Category"), accessor: "opt1.category" },
      );
    } else {
      columns.push({
        Header: languageService("Actions"),
        id: "actions",
        minWidth: 50,
        filterable: false,
        accessor: (d) => {
          return (
            <div>
              <ButtonActionsTable
                handleClick={() => {
                  this.setState({
                    selectedMaterial: d,
                  });
                  this.handleMaterialActionCallback("Edit", d);
                }}
                margin="0px 10px 0px 0px"
                buttonText={languageService("Edit")}
              />

              <ButtonActionsTable />
            </div>
          );
        },
      });
    }

    this.setState({
      materialTypeFormSchema: materialTypeFormSchema,
      columns: columns,
    });
  }
  openConfirmationDialog(title, message, displayAddInfo, action, confirmCallback) {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title={title}
          body={
            <Fragment>
              <div>{`${message}`}</div>
              {displayAddInfo}
            </Fragment>
          }
          action={action}
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={confirmCallback}
        />
      ),
    });
  }

  flattenMaterialTypes(data) {
    let sourceData = data || [];
    if (this.props.isIMS) {
      sourceData = sourceData.filter((mat) => mat.opt1 && mat.opt1.WIMS === true);
    } else {
      sourceData = sourceData.filter((mat) => !mat.opt1 || mat.opt1.WIMS !== true);
    }

    let flatMats = sourceData.map((mat) => {
      let obj = {
        desc: mat.description,
        code: mat.code,
        opt1: mat.opt1,
      };
      if (mat.opt1 && mat.opt1.attributes) {
        mat.opt1.attributes.forEach((attr) => {
          obj[attr.key] = attr.value;
        });
      }

      return obj;
    });

    this.setState({ materialTypesList: flatMats });
  }

  handleMaterialActionCallback(action, data) {
    const editState = () =>
      this.setState({
        openAddEditMaterialForm: true,
        materialFormState: "edit",
        openAddEditMaterialFormData: data,
      });

    const createState = () =>
      this.setState({
        openAddEditMaterialForm: true,
        materialFormState: "create",
        openAddEditMaterialFormData: {},
      });

    const deleteState = () => {
      this.openConfirmationDialog(
        `Confirm Delete: '${data.desc}'`,
        `Are you sure you want to delete?`,
        null,
        // confirmationDialogWarningMessage(`Note: `),
        "ConfirmDelete",
        this.handleMaterialActionCallback,
      );
    };

    const confirmDeleteState = () => {
      // let { selectedMaterial } = this.state;
      // let selectedMat = this.props.materialTypes.find((mat) => mat.code === selectedMaterial.code);
      // this.props.deleteApplicationlookups(selectedMat);
      this.deleteMaterialType();

      this.closeConfirmationDialog();
    };

    const key = {
      Edit: editState,

      Create: createState,

      Delete: deleteState,

      ConfirmDelete: confirmDeleteState,
    };

    key[action]();
  }
  addMaterialType(data) {
    const inputObject = data.fields;
    const value = [];

    //validate item no
    let found = this.state.materialTypesList.find((mat) => (mat["Item No"] || "").trim() === (inputObject["Item No"] || "").trim());

    if (found) {
      ToastService.Error(`${languageService("Error")}:`, languageService("Item No. already exists"));
      return;
    }
    let foundDescription = this.state.materialTypesList.find((mat) => (mat["desc"] || "").trim() === (inputObject["desc"] || "").trim());
    if (foundDescription) {
      ToastService.Error(`${languageService("Error")}:`, languageService("Description already exists"));
      return;
    }
    for (const key in inputObject) {
      if (key !== "desc") {
        value.push({ key: key, value: inputObject[key] });
      }
    }

    let dataObj = {
      tenantId: "ps19",
      listName: "materialTypes",
      description: inputObject.desc,
      opt1: { attributes: value },
      opt2: "",
    };

    this.props.createApplicationlookups(dataObj);
    this.closeDialog();
  }
  updateMaterialType(data) {
    let { selectedMaterial } = this.state;

    const inputObject = data.fields;
    const value = [];
    let foundDescription = this.state.materialTypesList
      .filter((e) => e.code !== selectedMaterial.code)
      .find((mat) => (mat["desc"] || "").trim() === (inputObject["desc"] || "").trim());
    if (foundDescription) {
      ToastService.Error(`${languageService("Error")}:`, languageService("Description already exists"));
      return;
    }
    for (const key in inputObject) {
      if (key !== "desc") {
        value.push({ key: key, value: inputObject[key] });
      }
    }

    let selectedMat = this.props.materialTypes.find((mat) => mat.code === selectedMaterial.code);
    if (selectedMat) {
      selectedMat.description = inputObject.desc;
      selectedMat.opt1["attributes"] = value;
      this.props.updateApplicationlookups(selectedMat);
    }

    this.closeDialog();
  }

  deleteMaterialType() {
    let { selectedMaterial } = this.state;
    let selectedMat = this.props.materialTypes.find((mat) => mat.code === selectedMaterial.code);
    if (selectedMat) {
      selectedMat.opt1["isRemoved"] = true;
      this.props.updateApplicationlookups(selectedMat);
    }

    this.closeDialog();
  }

  handlePageSave(page, pageSize) {
    this.setState({
      page: page,
      pageSize: pageSize,
    });
  }
  render() {
    let pageOptions = null;
    pageOptions = this.pageOptions.map((option) => {
      return (
        <DropdownItem
          onClick={(e) => {
            this.handlePageSave(0, option);
          }}
          key={option}
          style={themeService(commonFilterStyles.pageSizeStyle)}
        >
          {option}
        </DropdownItem>
      );
    });
    let { materialFormState, openAddEditMaterialForm, openAddEditMaterialFormData, materialTypeFormSchema, confirmationDialog, columns } =
      this.state;
    return (
      columns && (
        <Col className="mainContent" md="12">
          <Row>
            <Col md={this.props.imsActionComponent ? "9" : "11"}>
              <div style={themeService(commonPageStyle.commonSummaryHeadingContainer)}>
                <h4 style={themeService(commonPageStyle.commonSummaryHeadingStyle)}>{languageService("Material list")}</h4>
                {this.props.lastSynced && (
                  <div style={{ marginTop: "5px", whiteSpace: "nowrap" }}>
                    <small style={{ fontStyle: "italic" }}>
                      {languageService("Last Synced")}:{" "}
                      <span style={{ fontSize: "small", fontWeight: "700" }}>{moment(this.props.lastSynced).format("llll")}</span>
                    </small>
                  </div>
                )}
              </div>
              {/* TODO Create New Permission */}

              {!this.props.isIMS && (
                <div style={{ display: "inline-block", padding: "0 15px" }}>
                  <TooltipContainer tooltipText={languageService("Add Material Type")}>
                    <ButtonCirclePlus
                      handleClick={(e) => {
                        this.handleMaterialActionCallback("Create");
                      }}
                      {...themeService(commonSummaryStyle.addButtonStyle(this.props))}
                    />
                  </TooltipContainer>
                </div>
              )}
            </Col>

            {this.props.imsActionComponent && (
              <Col md="3" style={{ textAlign: "right", paddingRight: "30px", paddingTop: "10px" }}>
                {this.props.imsActionComponent}
              </Col>
            )}

            <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
          </Row>
          <Row>
            <Col md={1}>
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }} key="pageSize">
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} size="sm">
                  <DropdownToggle style={themeService(commonFilterStyles.pageSizeTogglerStyle)} caret>
                    {this.state.pageSize}
                  </DropdownToggle>
                  <DropdownMenu style={{ minWidth: "auto", fontSize: "12px", padding: "0px" }}>{pageOptions}</DropdownMenu>
                </Dropdown>
              </div>
            </Col>
            <Col md="12">
              <div style={{ padding: "0px 15px 15px", width: "-webkit-fill-available" }}>
                <ThisTable
                  tableColumns={columns}
                  tableData={this.state.materialTypesList}
                  pageSize={this.state.pageSize}
                  minRows={1}
                  pagination={true}
                  forDashboard={false}
                  handlePageChange={(page) => this.handlePageSave(page, this.state.pageSize)}
                  page={this.state.page}
                  height={"auto"}
                  // handleSelectedClick={this.setSelectedUser}
                  onClickSelect
                />
              </div>
            </Col>
          </Row>

          {openAddEditMaterialForm && materialTypeFormSchema && (
            <CustomForm
              mode="dialog"
              currState={materialFormState}
              fieldsData={openAddEditMaterialFormData}
              formSchema={materialTypeFormSchema}
              closeDialog={this.closeDialog}
              parentRef={{
                addMaterialType: this.addMaterialType,
                updateMaterialType: this.updateMaterialType,
              }}
            />
          )}
          {confirmationDialog}
        </Col>
      )
    );
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;
const updateApplicationlookups = curdActions.updateApplicationlookups;
const deleteApplicationlookups = curdActions.deleteApplicationlookups;
const createApplicationlookups = curdActions.createApplicationlookups;

let variableList = {
  diagnosticsReducer: {
    materialTypes: [],
    materialTypesSchema: [],
  },
  applicationlookupsReducer: { applicationlookupss: [] },
};

let actionOptions = {
  create: true,
  update: true,
  read: true,
  delete: true,
  others: {
    getAppMockupsTypes,

    getApplicationlookupss: getApplicationlookupss,
    updateApplicationlookups: updateApplicationlookups,
    deleteApplicationlookups: deleteApplicationlookups,
    createApplicationlookups: createApplicationlookups,
  },
};

let MaterialTypeListContainer = CRUDFunction(MaterialTypeList, "MaterialTypeList", actionOptions, variableList, [
  "diagnosticsReducer",
  "applicationlookupsReducer",
]);
export default MaterialTypeListContainer;



// WEBPACK FOOTER //
// ./src/components/MaterialTypeListView/MaterialTypeList.jsx